"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const loggerFactory_1 = __importDefault(require("../Util/Factory/loggerFactory"));
const DateTimeProvider_1 = require("../Util/DateTimeProvider");
const AuthCache_1 = __importDefault(require("../CacheLayer/Auth/AuthCache"));
const http_client_1 = require("@almservices-cl/http-client");
const Customer_1 = __importDefault(require("../BusinessLogicLayer/Customer"));
const CustomerCache_1 = __importDefault(require("../CacheLayer/Customer/CustomerCache"));
const Results_1 = __importDefault(require("../BusinessLogicLayer/Results"));
const AuthAndProfile_1 = __importDefault(require("../BusinessLogicLayer/AuthAndProfile"));
const PeriodPicker_1 = __importDefault(require("../ApiLayers/PeriodPicker"));
const Nutrition_1 = __importDefault(require("../BusinessLogicLayer/Nutrition/Nutrition"));
const NutritionCache_1 = __importDefault(require("../CacheLayer/Nutrition/NutritionCache"));
const BehaviourAdapter_1 = __importDefault(require("../BusinessLogicLayer/BehaviourAdapter"));
const Behaviour_1 = __importDefault(require("../BusinessLogicLayer/Behaviour"));
const Coach_1 = __importDefault(require("../BusinessLogicLayer/Coach"));
const NetworkSubscription_1 = require("../BusinessLogicLayer/NetworkSubscription");
const ChatCache_1 = require("../CacheLayer/Chat/ChatCache");
const IdentityService_1 = __importDefault(require("../BusinessLogicLayer/IdentityService"));
const Training_1 = __importDefault(require("../BusinessLogicLayer/Training"));
const EventBusImpl_1 = __importDefault(require("../Util/EventBus/EventBusImpl"));
const MessageSentListener_1 = __importDefault(require("../BusinessLogicLayer/Event/MessageSentListener"));
const TokenService_1 = __importDefault(require("../BusinessLogicLayer/TokenService"));
const Recovery_1 = __importDefault(require("../BusinessLogicLayer/Recovery"));
const RecoveryAdapter_1 = __importDefault(require("../BusinessLogicLayer/RecoveryAdapter"));
const CustomerAdapter_1 = __importDefault(require("../BusinessLogicLayer/CustomerAdapter"));
const CustomerSubscriptionBusiness_1 = __importDefault(require("../BusinessLogicLayer/CustomerSubscriptionBusiness"));
const CustomerNotificationsAdapter_1 = __importDefault(require("../ApiLayers/CustomerNotificationsAdapter"));
const BehaviourCache_1 = __importDefault(require("../CacheLayer/BehaviourCache"));
const TrainingCache_1 = __importDefault(require("../CacheLayer/TrainingCache"));
const RecoveryCache_1 = __importDefault(require("../CacheLayer/Recovery/RecoveryCache"));
const CalorieBudgetUtils_1 = __importDefault(require("../BusinessLogicLayer/CalorieBudgetUtils"));
const cache_1 = require("@almservices-cl/cache");
const clock_1 = require("@almservices-cl/clock");
const chat_1 = require("@almservices-cl/chat");
const cache_2 = require("@almservices-cl/cache");
const cache_3 = require("@almservices-cl/cache");
const TraineeListApi_1 = __importDefault(require("../ApiLayers/PBP10/TraineeList/TraineeListApi"));
const TraineeList_1 = __importDefault(require("../BusinessLogicLayer/TraineeList"));
const History_1 = __importDefault(require("../BusinessLogicLayer/History"));
const sport_activity_1 = require("@almservices-cl/sport-activity");
const NutritionUtils_1 = __importDefault(require("../BusinessLogicLayer/Nutrition/NutritionUtils"));
const config_consts_1 = require("./config.consts");
const JournalAdapter_1 = __importDefault(require("../BusinessLogicLayer/JournalAdapter"));
const JournalCache_1 = __importDefault(require("../CacheLayer/Journal/JournalCache"));
const Journal_1 = __importDefault(require("../BusinessLogicLayer/Journal"));
const cacheRecipe = (strategy, c) => {
    const networkSubscription = c.get(config_consts_1.NETWORK_SUBSCRIPTION);
    networkSubscription.subscribe(async (isOffline) => {
        if (isOffline) {
            strategy.goCacheOnly();
            return;
        }
        strategy.goRegular();
    });
};
exports.default = {
    container: {
        entries: {
            [config_consts_1.LOGGER_API]: (0, loggerFactory_1.default)("API"),
            [config_consts_1.LOGGER_APP]: (0, loggerFactory_1.default)("APP"),
            [config_consts_1.LOGGER_CACHE]: (0, loggerFactory_1.default)("CACHE"),
            [config_consts_1.DATE_TIME_PROVIDER]: (c) => new DateTimeProvider_1.DateTimeProviderImpl(c.get(config_consts_1.USER_DATE_TIME_CONFIG), c.get(config_consts_1.CONFIG_LOCALE)),
            [config_consts_1.SYSTEM_DATE_TIME_PROVIDER]: (c) => new DateTimeProvider_1.DateTimeProviderImpl(c.get(config_consts_1.SYSTEM_DATE_TIME_CONFIG), c.get(config_consts_1.CONFIG_LOCALE)),
            [config_consts_1.DATE_TIME_MODIFIER]: (c) => new DateTimeProvider_1.DateTimeModifierImpl(c.get(config_consts_1.USER_DATE_TIME_CONFIG)),
            [config_consts_1.SYSTEM_DATE_TIME_MODIFIER]: (c) => new DateTimeProvider_1.DateTimeModifierImpl(c.get(config_consts_1.SYSTEM_DATE_TIME_CONFIG)),
            [config_consts_1.DATE_TIME_BRIDGE]: () => {
                return new clock_1.DateTimeBridgeImpl();
            },
            [config_consts_1.EVENT_BUS]: (c) => {
                return new EventBusImpl_1.default(c.get(config_consts_1.LOGGER_APP));
            },
            [config_consts_1.CONFIG_LOCALE]: () => {
                return new clock_1.MutableLocale("nl_NL");
            },
            [config_consts_1.CONFIG_LANGUAGE]: () => {
                return new http_client_1.Mutable("nl_NL");
            },
            [config_consts_1.CONFIG_UNIT]: () => {
                return new http_client_1.Mutable(http_client_1.Unit.METRIC);
            },
            [config_consts_1.AUTH_CACHE]: (c) => new AuthCache_1.default(c.get(config_consts_1.CACHE)),
            [config_consts_1.TOKEN_SERVICE]: (c) => new TokenService_1.default(c.get(config_consts_1.HTTP_CLIENT), c.get(config_consts_1.AUTH_CACHE), c.get(config_consts_1.DATE_TIME_PROVIDER)),
            [config_consts_1.IDENTITY_SERVICE]: (c) => {
                return new IdentityService_1.default(c.get(config_consts_1.COACH));
            },
            [config_consts_1.CUSTOMER]: (c) => {
                return new Customer_1.default(c.get(config_consts_1.CUSTOMER_LIST), c.get(config_consts_1.CUSTOMER_NOTES), c.get(config_consts_1.TOKEN_SERVICE), c.get(config_consts_1.CUSTOMER_CACHE), c.get(config_consts_1.CUSTOMER_NOTIFICATIONS), c.get(config_consts_1.NUTRITION_CALORIE_BUDGET), c.get(config_consts_1.NUTRITION_FOOD_PREFERENCE), c.get(config_consts_1.NETWORK_FIRST_STRATEGY), c.get(config_consts_1.DATE_TIME_BRIDGE), c.get(config_consts_1.LOGGER_APP), new CustomerAdapter_1.default(c.get(config_consts_1.DATE_TIME_BRIDGE), c.get(config_consts_1.SYSTEM_DATE_TIME_PROVIDER), c.get(config_consts_1.DATE_TIME_MODIFIER), c.get(config_consts_1.DATE_TIME_PROVIDER)), c.get(config_consts_1.CUSTOMER_SUBSCRIPTION_BUSINESS), c.get(config_consts_1.DAY_TYPE_API));
            },
            [config_consts_1.COACH]: (c) => {
                return new Coach_1.default(c.get(config_consts_1.DATE_TIME_PROVIDER), c.get(config_consts_1.COACH_RATING_LIST), c.get(config_consts_1.COACH_CAPACITY), c.get(config_consts_1.COACH_USER), c.get(config_consts_1.TOKEN_SERVICE), c.get(config_consts_1.NETWORK_FIRST_STRATEGY), c.get(config_consts_1.CACHE_STRATEGY), c.get(config_consts_1.COACH_MONTHLY_MEMBERS_OVERVIEW), c.get(config_consts_1.CONDITIONAL_CACHE_STRATEGY), c.get(config_consts_1.DATE_TIME_MODIFIER));
            },
            [config_consts_1.MESSAGE_MAKER]: (c) => {
                return new chat_1.MessageFactory(c.get(config_consts_1.DATE_TIME_PROVIDER));
            },
            [config_consts_1.CHAT]: (c) => {
                return new chat_1.Chat(c.get(config_consts_1.PBP_CHAT_API), c.get(config_consts_1.PMP_CHAT_API), c.get(config_consts_1.CHAT_CACHE), c.get(config_consts_1.CHAT_QUEUE), c.get(config_consts_1.IDENTITY_SERVICE), c.get(config_consts_1.MESSAGE_MAKER), c.get(config_consts_1.EVENT_BUS), c.get(config_consts_1.HTTP_CLIENT));
            },
            [config_consts_1.CHAT_CACHE]: (c) => {
                return new ChatCache_1.ChatCacheImpl(c.get(config_consts_1.CACHE));
            },
            [config_consts_1.CUSTOMER_CACHE]: (c) => {
                return new CustomerCache_1.default(c.get(config_consts_1.CACHE), c.get(config_consts_1.LOGGER_CACHE), c.get(config_consts_1.NETWORK_FIRST_STRATEGY));
            },
            [config_consts_1.CACHE_STRATEGY]: (c) => new cache_1.CacheFirstStrategy(c.get(config_consts_1.CACHE)),
            [config_consts_1.NETWORK_FIRST_STRATEGY]: (c) => new cache_1.NetworkFirstStrategy(c.get(config_consts_1.CACHE)),
            [config_consts_1.CONDITIONAL_CACHE_STRATEGY]: (c) => new cache_1.ConditionalCacheFirstStrategy(c.get(config_consts_1.CACHE)),
            [config_consts_1.TIMER_STRATEGY]: (c) => {
                const TimerConstructor = c.get(config_consts_1.TIMER);
                return new cache_1.TimerStrategyImpl(c.get(config_consts_1.CACHE), new TimerConstructor(5 * 60));
            },
            [config_consts_1.CUSTOMER_NOTIFICATIONS]: (c) => {
                return new CustomerNotificationsAdapter_1.default(c.get(config_consts_1.TOKEN_SERVICE), c.get(config_consts_1.CUSTOMER_NOTIFICATIONS_API));
            },
            [config_consts_1.CUSTOMER_SUBSCRIPTION_BUSINESS]: (c) => new CustomerSubscriptionBusiness_1.default(c.get(config_consts_1.DATE_TIME_BRIDGE)),
            [config_consts_1.TRAINING]: (c) => {
                return new Training_1.default(c.get(config_consts_1.CACHE), c.get(config_consts_1.TRAINING_CACHE), c.get(config_consts_1.TRAINING_API), c.get(config_consts_1.DATE_TIME_BRIDGE), c.get(config_consts_1.FETCH), c.get(config_consts_1.LOGGER_APP));
            },
            [config_consts_1.TRAINING_CACHE]: (c) => {
                return new TrainingCache_1.default(c.get(config_consts_1.NETWORK_FIRST_COMPOSITE_STRATEGY), c.get(config_consts_1.CACHE_STRATEGY), c.get(config_consts_1.NETWORK_FIRST_STRATEGY));
            },
            [config_consts_1.RESULTS]: (c) => {
                return new Results_1.default(c.get(config_consts_1.MEASUREMENTS_API), c.get(config_consts_1.CUSTOMER), c.get(config_consts_1.CONDITIONAL_CACHE_STRATEGY), c.get(config_consts_1.FETCH), c.get(config_consts_1.DATE_TIME_BRIDGE));
            },
            [config_consts_1.AUTH]: (c) => {
                return new AuthAndProfile_1.default(c.get(config_consts_1.AUTH_API), c.get(config_consts_1.TOKEN_SERVICE), c.get(config_consts_1.CACHE), c.get(config_consts_1.HTTP_CLIENT));
            },
            [config_consts_1.SUBSCRIPTION_PICKER]: (c) => {
                return new PeriodPicker_1.default(c.get(config_consts_1.SYSTEM_DATE_TIME_PROVIDER), c.get(config_consts_1.SYSTEM_DATE_TIME_MODIFIER));
            },
            [config_consts_1.NUTRITION_CACHE]: (c) => {
                return new NutritionCache_1.default(c.get(config_consts_1.CONDITIONAL_CACHE_STRATEGY), c.get(config_consts_1.NETWORK_FIRST_COMPOSITE_STRATEGY), c.get(config_consts_1.SYSTEM_DATE_TIME_PROVIDER), c.get(config_consts_1.SYSTEM_DATE_TIME_MODIFIER), c.get(config_consts_1.CONFIG_UNIT));
            },
            [config_consts_1.NUTRITION]: (c) => {
                return new Nutrition_1.default(c.get(config_consts_1.NUTRITION_API), c.get(config_consts_1.NUTRITION_CACHE), c.get(config_consts_1.DATE_TIME_BRIDGE), c.get(config_consts_1.CALORIE_BUDGET_UTILS), c.get(config_consts_1.NUTRITION_UTILS));
            },
            [config_consts_1.NUTRITION_UTILS]: () => {
                return new NutritionUtils_1.default();
            },
            [config_consts_1.CALORIE_BUDGET_UTILS]: (c) => {
                return new CalorieBudgetUtils_1.default(c.get(config_consts_1.DATE_TIME_MODIFIER));
            },
            [config_consts_1.USER_DATE_TIME_CONFIG]: (c) => {
                return new clock_1.DateTimeConfig(c.get(config_consts_1.CACHE), {
                    dateTime: "DD-MM-YYYY HH:mm:ss",
                    date: "DD-MM-YYYY",
                    time: "HH:mm:ss",
                });
            },
            [config_consts_1.SYSTEM_DATE_TIME_CONFIG]: () => {
                return new clock_1.DateTimeConfig(new cache_1.InMemoryCache(), {
                    dateTime: "YYYY-MM-DDTHH:mm:ssZ",
                    date: "YYYY-MM-DD",
                    time: "HH:mm:ss",
                });
            },
            [config_consts_1.BEHAVIOUR_ADAPTER]: (c) => {
                return new BehaviourAdapter_1.default(c.get(config_consts_1.BEHAVIOUR_API), c.get(config_consts_1.DATE_TIME_PROVIDER), c.get(config_consts_1.DATE_TIME_BRIDGE));
            },
            [config_consts_1.BEHAVIOUR_CACHE]: (c) => {
                return new BehaviourCache_1.default(c.get(config_consts_1.NETWORK_FIRST_COMPOSITE_STRATEGY), c.get(config_consts_1.CACHE_STRATEGY), c.get(config_consts_1.DATE_TIME_BRIDGE));
            },
            [config_consts_1.BEHAVIOUR]: (c) => {
                return new Behaviour_1.default(c.get(config_consts_1.BEHAVIOUR_ADAPTER), c.get(config_consts_1.DATE_TIME_PROVIDER), c.get(config_consts_1.DATE_TIME_BRIDGE), c.get(config_consts_1.BEHAVIOUR_CACHE));
            },
            [config_consts_1.NETWORK_SUBSCRIPTION]: (c) => {
                return new NetworkSubscription_1.NetworkSubscriptionImpl(c.get(config_consts_1.LOGGER_APP));
            },
            [config_consts_1.CHAT_QUEUE]: (c) => {
                return new chat_1.ChatQueueImpl(c.get(config_consts_1.CACHE));
            },
            [config_consts_1.CHAT_PROCESSOR]: (c) => {
                return new chat_1.ChatProcessorImpl(c.get(config_consts_1.CHAT_QUEUE), c.get(config_consts_1.PBP_CHAT_API), c.get(config_consts_1.PMP_CHAT_API), c.get(config_consts_1.LOGGER_APP), c.get(config_consts_1.MESSAGE_MAKER), c.get(config_consts_1.CHAT_CACHE), c.get(config_consts_1.IDENTITY_SERVICE));
            },
            [config_consts_1.MESSAGE_SENT_LISTENER]: (c) => {
                return new MessageSentListener_1.default(c.get(config_consts_1.CUSTOMER), c.get(config_consts_1.LOGGER_APP));
            },
            [config_consts_1.TIMER]: () => {
                return cache_2.Timer;
            },
            [config_consts_1.RECOVERY]: (c) => {
                return new Recovery_1.default(c.get(config_consts_1.RECOVERY_ADAPTER), c.get(config_consts_1.DATE_TIME_PROVIDER), c.get(config_consts_1.RECOVERY_CACHE), c.get(config_consts_1.DATE_TIME_BRIDGE));
            },
            [config_consts_1.RECOVERY_ADAPTER]: (c) => {
                return new RecoveryAdapter_1.default(c.get(config_consts_1.RECOVERY_API));
            },
            [config_consts_1.RECOVERY_CACHE]: (c) => {
                return new RecoveryCache_1.default(c.get(config_consts_1.NETWORK_FIRST_COMPOSITE_STRATEGY));
            },
            [config_consts_1.JOURNAL]: (c) => {
                return new Journal_1.default(c.get(config_consts_1.JOURNAL_ADAPTER), c.get(config_consts_1.JOURNAL_CACHE));
            },
            [config_consts_1.JOURNAL_ADAPTER]: (c) => {
                return new JournalAdapter_1.default(c.get(config_consts_1.JOURNAL_API));
            },
            [config_consts_1.JOURNAL_CACHE]: (c) => {
                return new JournalCache_1.default(c.get(config_consts_1.CACHE_STRATEGY));
            },
            [config_consts_1.HTTP_CLIENT]: () => {
                return null;
            },
            [config_consts_1.NETWORK_FIRST_COMPOSITE_STRATEGY]: (c) => {
                return new cache_3.NetworkFirstCompositeCacheStrategy(c.get(config_consts_1.CACHE));
            },
            [config_consts_1.TRAINEE_LIST_API]: (c) => {
                return new TraineeListApi_1.default(c.get(config_consts_1.GRAPHQL_CLIENT));
            },
            [config_consts_1.TRAINEE_LIST]: (c) => {
                return new TraineeList_1.default(c.get(config_consts_1.NETWORK_FIRST_STRATEGY), c.get(config_consts_1.TRAINEE_LIST_API));
            },
            [config_consts_1.HISTORY]: (c) => {
                return new History_1.default(c.get(config_consts_1.HISTORY_API), c.get(config_consts_1.CONDITIONAL_CACHE_STRATEGY), c.get(config_consts_1.CALORIE_BUDGET_UTILS), c.get(config_consts_1.CONFIG_LOCALE));
            },
            [config_consts_1.SPORT_ACTIVITY_CACHE]: (c) => {
                return new sport_activity_1.SportActivityCache(c.get(config_consts_1.NETWORK_FIRST_COMPOSITE_STRATEGY));
            },
            [config_consts_1.SPORT_ACTIVITY]: (c) => {
                return new sport_activity_1.SportActivity(c.get(config_consts_1.SPORT_ACTIVITY_API), c.get(config_consts_1.SPORT_ACTIVITY_CACHE));
            },
        },
        recipes: {
            [config_consts_1.CACHE_STRATEGY]: cacheRecipe,
            [config_consts_1.CONDITIONAL_CACHE_STRATEGY]: cacheRecipe,
            [config_consts_1.NETWORK_FIRST_STRATEGY]: cacheRecipe,
            [config_consts_1.NETWORK_FIRST_COMPOSITE_STRATEGY]: cacheRecipe,
            [config_consts_1.CHAT]: (chat, c) => {
                const networkSubscription = c.get(config_consts_1.NETWORK_SUBSCRIPTION);
                c.get(config_consts_1.CHAT_PROCESSOR); // to make it running :)
                networkSubscription.subscribe((isOffline) => {
                    if (isOffline) {
                        return chat.goOffline();
                    }
                    return chat.goOnline();
                });
            },
            [config_consts_1.CHAT_PROCESSOR]: (chatProcessor, c) => {
                const networkSubscription = c.get(config_consts_1.NETWORK_SUBSCRIPTION);
                networkSubscription.subscribe((isOffline) => {
                    if (isOffline) {
                        return chatProcessor.goOffline();
                    }
                    return chatProcessor.goOnline();
                });
            },
            [config_consts_1.CUSTOMER]: (customer, c) => {
                const networkSubscription = c.get(config_consts_1.NETWORK_SUBSCRIPTION);
                networkSubscription.subscribe(async (_isOffline) => customer.resetCustomersObservable());
            },
            [config_consts_1.EVENT_BUS]: (eventBus, c) => {
                eventBus.registerListener(c.get(config_consts_1.MESSAGE_SENT_LISTENER));
            },
            [config_consts_1.DATE_TIME_BRIDGE]: (dateTimeBridge, c) => {
                const config = c.get(config_consts_1.USER_DATE_TIME_CONFIG);
                config.onChange({
                    setFormats(dateTime, date, time) {
                        dateTimeBridge.setUserFormat({
                            date,
                            dateTime,
                            time,
                        });
                    },
                });
                const systemConfig = c.get(config_consts_1.SYSTEM_DATE_TIME_CONFIG);
                systemConfig.onChange({
                    setFormats(dateTime, date, time) {
                        dateTimeBridge.setSystemFormat({
                            date,
                            dateTime,
                            time,
                        });
                    },
                });
            },
        },
    },
};
//# sourceMappingURL=config.js.map